export async function fetchBuildId(): Promise<string> {
  const response = await fetch('/api/build-id', { cache: 'no-store' });
  const { buildId } = (await response.json()) as { buildId: string };

  return buildId;
}
